import { render, staticRenderFns } from "./ParcelInsurance.vue?vue&type=template&id=7009a23d&"
import script from "./ParcelInsurance.vue?vue&type=script&lang=js&"
export * from "./ParcelInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports